import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./GlobalStyles";
import theme from "./theme";
import "focus-visible";
const SproutUIThemeProvider = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ _jsxs(ThemeProvider, {
        theme: theme,
        children: [
            /*#__PURE__*/ _jsx(GlobalStyles, {}),
            children
        ]
    });
};
export default SproutUIThemeProvider;
